<script setup lang="ts">
import { useI18n } from 'vue-i18n';

/*
 * Google allows hiding the reCAPTCHA badge only if the attribution is shown in the
 * user flow instead: https://developers.google.com/recaptcha/docs/faq#id-like-to-hide-the-recaptcha-badge.-what-is-allowed
 * The badge is hidden in apps/juno/src/styles/main.scss, so this notice is what keeps
 * Juno compliant wherever reCAPTCHA actually runs. Comet renders the same notice from
 * its Initial view.
 */
const PRIVACY_POLICY_URL = 'https://policies.google.com/privacy';
const TERMS_OF_SERVICE_URL = 'https://policies.google.com/terms';

const { t } = useI18n();
</script>

<template>
  <i18n-t
    keypath="common.recaptcha.attribution"
    scope="global"
    tag="p"
    class="recaptcha-attribution typography-body-sm text--color-text-tertiary text-center px-4 pb-4"
    data-testid="recaptcha-attribution">
    <template #privacyPolicy>
      <a :href="PRIVACY_POLICY_URL" target="_blank" rel="noopener noreferrer">
        {{ t('common.recaptcha.privacyPolicy') }}
      </a>
    </template>
    <template #termsOfService>
      <a :href="TERMS_OF_SERVICE_URL" target="_blank" rel="noopener noreferrer">
        {{ t('common.recaptcha.termsOfService') }}
      </a>
    </template>
  </i18n-t>
</template>

<style scoped>
/* The links are part of a muted legal notice, so they follow the paragraph token
   colour rather than standing out as regular links. */
.recaptcha-attribution a {
  color: inherit;
  text-decoration: underline;
}
</style>
